"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrbContentRenderingType = exports.IrbContentType = exports.PackagePartStatus = exports.IrbStatus = void 0;
var IrbStatus;
(function (IrbStatus) {
    IrbStatus["PROCESSING"] = "processing";
    IrbStatus["SUCCESS"] = "success";
    IrbStatus["FAILURE"] = "failure";
})(IrbStatus || (exports.IrbStatus = IrbStatus = {}));
var PackagePartStatus;
(function (PackagePartStatus) {
    PackagePartStatus["PROCESSING"] = "processing";
    PackagePartStatus["SUCCESS"] = "success";
    PackagePartStatus["FAILURE"] = "failure";
})(PackagePartStatus || (exports.PackagePartStatus = PackagePartStatus = {}));
var IrbContentType;
(function (IrbContentType) {
    // Sign Up
    IrbContentType["SIGN_UP_STUDY_CODE"] = "SIGN_UP_STUDY_CODE";
    IrbContentType["SIGN_UP_INVITE_CODE"] = "SIGN_UP_INVITE_CODE";
    IrbContentType["SIGN_UP_RESEND_INVITE_CODE"] = "SIGN_UP_RESEND_INVITE_CODE";
    // Sign In
    IrbContentType["SIGN_IN_USERNAME_PW"] = "SIGN_IN_USERNAME_PW";
    IrbContentType["SIGN_IN_USERNAME_PW_ERROR"] = "SIGN_IN_USERNAME_PW_ERROR";
    IrbContentType["SIGN_IN_EMAIL_PW"] = "SIGN_IN_EMAIL_PW";
    IrbContentType["SIGN_IN_EMAIL_PW_UN_PW_ERROR_DIALOG"] = "SIGN_IN_EMAIL_PW_UN_PW_ERROR_DIALOG";
    IrbContentType["SIGN_IN_EMAIL_PW_ERROR"] = "SIGN_IN_EMAIL_PW_ERROR";
    IrbContentType["SIGN_IN_RESET_PASSWORD"] = "SIGN_IN_RESET_PASSWORD";
    IrbContentType["SIGN_IN_CONTACT_SUPPORT"] = "SIGN_IN_CONTACT_SUPPORT";
    // Authentication
    IrbContentType["AUTHENTICATION_UN_PW"] = "AUTHENTICATION_UN_PW";
    IrbContentType["AUTHENTICATION_EMAIL_PW"] = "AUTHENTICATION_EMAIL_PW";
    IrbContentType["AUTHENTICATION_EMAIL_PW_NAME"] = "AUTHENTICATION_EMAIL_PW_NAME";
    IrbContentType["AUTHENTICATION_EMAIL_PW_PHONE"] = "AUTHENTICATION_EMAIL_PW_PHONE";
    IrbContentType["AUTHENTICATION_EMAIL_PW_NAME_PHONE"] = "AUTHENTICATION_EMAIL_PW_NAME_PHONE";
    IrbContentType["AUTHENTICATION_INLINE_VALIDATION_ERRORS"] = "AUTHENTICATION_INLINE_VALIDATION_ERRORS";
    IrbContentType["AUTHENTICATION_LIST_ALL_INLINE_VALIDATION_VALUES"] = "AUTHENTICATION_LIST_ALL_INLINE_VALIDATION_VALUES";
    IrbContentType["AUTHENTICATION_DIALOG_ERRORS"] = "AUTHENTICATION_DIALOG_ERRORS";
    IrbContentType["AUTHENTICATION_LIST_ALL_DIALOG_VALIDATION_VALUES"] = "AUTHENTICATION_LIST_ALL_DIALOG_VALIDATION_VALUES";
    // Schedule
    IrbContentType["SCHEDULE_FIRST_TIME_USER_NAVIGATES"] = "SCHEDULE_FIRST_TIME_USER_NAVIGATES";
    IrbContentType["SCHEDULE_LIST_ALL_ACTIVITY_NAMES"] = "SCHEDULE_LIST_ALL_ACTIVITY_NAMES";
    // Activities
    IrbContentType["ACTIVITIES"] = "ACTIVITIES";
    IrbContentType["ACTIVITIES_APPENDIX"] = "ACTIVITIES_APPENDIX";
    // Activities Validation
    IrbContentType["ACTIVITIES_VALIDATION_NDE"] = "ACTIVITIES_VALIDATION_NDE";
    IrbContentType["ACTIVITIES_VALIDATION_DATE_TIME"] = "ACTIVITIES_VALIDATION_DATE_TIME";
    IrbContentType["ACTIVITIES_VALIDATION_TEXT_INPUTS"] = "ACTIVITIES_VALIDATION_TEXT_INPUTS";
    // Activities Modals
    IrbContentType["ACTIVITIES_MODALS_SKIP"] = "ACTIVITIES_MODALS_SKIP";
    IrbContentType["ACTIVITIES_MODALS_CANCEL"] = "ACTIVITIES_MODALS_CANCEL";
    IrbContentType["ACTIVITIES_MODALS_SPECIFIC_DIALOG"] = "ACTIVITIES_MODALS_SPECIFIC_DIALOG";
    // Resources
    IrbContentType["RESOURCES_LIST"] = "RESOURCES_LIST";
    IrbContentType["RESOURCES_LIST_ALL"] = "RESOURCES_LIST_ALL";
    IrbContentType["RESOURCES_URL"] = "RESOURCES_URL";
    IrbContentType["RESOURCES_PDF"] = "RESOURCES_PDF";
    IrbContentType["RESOURCES_RICH_TEXT"] = "RESOURCES_RICH_TEXT";
    // Notifications
    IrbContentType["NOTIFICATION_SMS"] = "NOTIFICATION_SMS";
    IrbContentType["NOTIFICATION_PUSH_NOTIFICATION"] = "NOTIFICATION_PUSH_NOTIFICATION";
    IrbContentType["NOTIFICATION_EMAIL"] = "NOTIFICATION_EMAIL";
    IrbContentType["NOTIFICATIONS_STANDARD"] = "NOTIFICATIONS_STANDARD";
    // Participant App
    IrbContentType["PARTICIPANT_APP_SETTINGS"] = "PARTICIPANT_APP_SETTINGS";
    IrbContentType["PARTICIPANT_APP_PROFILE_SWITCHER"] = "PARTICIPANT_APP_PROFILE_SWITCHER";
    // Televisit
    IrbContentType["TELEVISIT_SCHEDULE_VIEW"] = "TELEVISIT_SCHEDULE_VIEW";
    IrbContentType["TELEVISIT_WAITING_ROOM"] = "TELEVISIT_WAITING_ROOM";
    // eConsent
    IrbContentType["ECONSENT_INTRODUCTION_PAGE"] = "ECONSENT_INTRODUCTION_PAGE";
    IrbContentType["ECONSENT_SIGNATURE_SIGNING"] = "ECONSENT_SIGNATURE_SIGNING";
})(IrbContentType || (exports.IrbContentType = IrbContentType = {}));
var IrbContentRenderingType;
(function (IrbContentRenderingType) {
    IrbContentRenderingType["SCREENSHOTS"] = "screenshots";
    IrbContentRenderingType["LIST"] = "list";
    IrbContentRenderingType["NOTIFICATION_PUSH_NOTIFICATION"] = "notification_push_notification";
    IrbContentRenderingType["NOTIFICATION_SMS"] = "notification_sms";
    IrbContentRenderingType["NOTIFICATION_EMAIL"] = "notification_email";
})(IrbContentRenderingType || (exports.IrbContentRenderingType = IrbContentRenderingType = {}));
//# sourceMappingURL=types.js.map